module.exports = __webpack_public_path__ + "static/media/stop-3.d5b2fd6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-3.svg
// module id = 1370
// module chunks = 0